import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {I18nModule, provideDefaultConfig, CmsConfig, provideConfig} from '@spartacus/core';
import { IconModule, GenericLinkModule } from '@spartacus/storefront';
import { UigNavigationUiComponent } from './uig-navigation-ui.component';
import { UigNavigationComponent } from './uig-navigation.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        IconModule,
        GenericLinkModule,
        I18nModule,
    ],
    providers: [
        provideConfig(<CmsConfig>{
            cmsComponents: {
                NavigationComponent: {
                    component: UigNavigationComponent,
                },
            },
        }),
    ],
    declarations: [UigNavigationComponent, UigNavigationUiComponent],
    exports: [UigNavigationComponent, UigNavigationUiComponent]
})
export class UigNavigationModule { }
